<template>
  <div id="professionalDetailTab">
    <v-form ref="frmMain" lazy-validation>
      <v-row>
        <v-col cols="12" class="text-center text-md-left"><h1>Job Preferences</h1></v-col>
        <v-col cols="12"
          ><InfoBox
            title="Tell us about your Job Preferences, and your main Area of expertise. This will help us to match you with your perfect role, and help employers see if their project is the right fit for you."
        /></v-col>
        <v-col cols="12"
          ><v-card :loading="dataLoading">
            <v-card-title>Your Main Expertise</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <span class="f-body-1">In which field do you have the most experience?</span>
                </v-col>
                <v-col md="4" cols="12">
                  <AutoCompleteField
                    :readonly="isHiringmanager"
                    dense
                    placeholder="Position"
                    item-title="Name"
                    item-value="id"
                    :rules="[validations.required]"
                    :items="jobRoles"
                    v-model="selectedJobRole"
                    outlined
                  />
                </v-col>
                <v-col md="4" cols="12">
                  <ComboBoxField
                    :readonly="isHiringmanager && !selectedJobRole"
                    id="jobTitle"
                    clearable
                    placeholder="Title"
                    :items="jobTitles"
                    outlined
                    dense
                    item-title="Name"
                    item-value="id"
                    :rules="[validations.required]"
                    closable-chips
                    @update:modelValue="getJobTitle"
                    v-model="selectedJobTitle"
                  />
                </v-col>
                <v-col cols="12">
                  <span class="f-body-1">How Many years of Experience do you have in this field?</span>
                </v-col>
                <v-col md="4" cols="12">
                  <AutoCompleteField
                    :readonly="isHiringmanager"
                    dense
                    outlined
                    hint="Determine the amount of your total experience"
                    :items="experienceYears"
                    :rules="[validations.required, validations.ValidItem(experienceYears)]"
                    placeholder="Total years of experience"
                    v-model="selectedExperienceYear"
                  />
                </v-col>
              </v-row>
            </v-card-text> </v-card
        ></v-col>
        <v-col cols="12">
          <ExperienceDetailJobPreferences
            :isHiringmanager="isHiringmanager"
            :jobTitles="details.filter((item) => item.Type == 'JobTitle')"
            :jobPreferencesList="teamMember?.JobPreferences"
            @SaveJobPreferences="SaveJobPreferences"
            @removeJobPreferences="removeJobPreferences"
            :loading="submitting"
            :showRequired="true"
          />
        </v-col>
      </v-row>

      <!-- <v-card class="mt-5">
        <v-card-text>
          <v-col md="12">
            <p>Tell us a little about your personality. it helps us to know more about you!</p>
            <TextAreaFieldWithAIGenerator
              :options="options"
              :readonly="isHiringmanager"
              id="ExperienceDetailDescription"
              placeholder="For example: High impact ability, quick understanding of large complex systems, listening to customers, eager to learn programming languages and different technologies, very professional in teamwork and independent work."
              label="Personality"
              showRequired
              counter
              :rules="[validations.required, validations.minCharDesc]"
              v-model="professeionalDetail.Personality"
              outlined
            />
          </v-col>
        </v-card-text>
      </v-card> -->

      <v-card-actions v-if="isAfterSignUp">
        <!-- <v-col md="12" class="text-center pb-0 pt-0">
            <p>You're one step closer to unlocking access to working with the world's top companies!</p>
          </v-col> -->
        <div class="wizard-action">
          <v-tooltip top attach>
            <template v-slot:activator="{ props }">
              <v-btn
                v-if="!isHiringmanager"
                class="secondary_btn"
                v-bind="props"
                @click="getAllDataAndSubmit(true)"
                :disabled="submitting"
                :loading="submitting"
                prepend-icon="mdi-check"
                >Save and exit</v-btn
              >
            </template>
            <span>You can save your progress and return to the application process later</span>
          </v-tooltip>

          <div class="d-flex ga-5">
            <v-btn
              v-if="!isHiringmanager"
              class="primary_btn"
              @click="goBack"
              :disabled="submitting"
              :loading="submitting"
              prepend-icon="mdi-chevron-left"
              >Back</v-btn
            >
            <v-btn
              v-if="!isHiringmanager"
              class="primary_btn"
              @click="getAllDataAndSubmit(false)"
              :disabled="submitting"
              :loading="submitting"
              append-icon="mdi-chevron-right"
              >Next
            </v-btn>
          </div>
        </div>
      </v-card-actions>

      <v-card-actions v-else class="mt-5">
        <v-col md="12" class="text-center">
          <v-btn
            v-if="!isHiringmanager"
            class="primary_btn actionButton"
            @click="submitForm()"
            :disabled="submitting"
            :loading="submitting"
            prepend-icon="mdi-check"
            >Save</v-btn
          >
        </v-col>
      </v-card-actions>
    </v-form>
    <v-dialog v-model="showSaveForLaterConfirm" max-width="500" @keydown.esc="showSaveForLaterConfirm = false">
      <confirm-dialog :loading="savingLoading" :message="confirmModel" @confirm="save(true, true)" @cancel="cancelSaving"></confirm-dialog>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { ProfessionalDetailModel } from "../../services/openApi/api";
import { Profile } from "../../definitions/config";
import validations from "../../utils/validations";
import Details from "../../models/Details";
import ConfirmDialog from "../ConfirmDialog.vue";
import ExperienceDetailJobPreferences from "./ExperienceDetailJobPreferences.vue";
import AutoCompleteField from "../Fields/AutoCompleteField.vue";
import TextAreaFieldWithAIGenerator from "../Fields/TextAreaFieldWithAIGenerator.vue";
import ComboBoxField from "../Fields/ComboBoxField.vue";
import InfoBox from "../InfoBox.vue";
export default defineComponent({
  props: ["teamMember", "formLoading", "sendReqeustLoading", "loading", "details", "professionalDetailModel", "isAfterSignUp", "isHiringmanager"],
  components: {
    InfoBox,
    ConfirmDialog,
    ExperienceDetailJobPreferences,
    AutoCompleteField,
    TextAreaFieldWithAIGenerator,
    ComboBoxField,
  },
  data() {
    return {
      options: [
        {
          title: "Which one better describes you:",
          selected: "",
          choices: ["done is better than perfect.", "everything has to look perfect."],
        },
        {
          title: "How do you prefer to get feedback from your manager:",
          selected: "",
          choices: ["through formal performance reviews.", "daily/weekly meetings."],
        },
      ],
      validations,
      dataLoading: false,
      jobRoles: [] as Details[],
      jobTitles: [] as Details[],
      shouldRequest: true,
      requestLoading: false,
      selectedJobRole: "",
      showSaveForLaterConfirm: false,
      selectedJobTitle: null as Details | null,
      experienceYears: Profile.Members.SkillExperienceList,
      selectedExperienceYear: null as string | null,
      selectedPreferredLocation: "",
      selectedSeiorityLevel: "",
      seniorityLevels: Profile.Members.ProfessionalDetailLevel,
      locationTypes: Profile.Members.LocationTypes,
      filteredJobTitles: [] as string[],
      employmentTypes: Profile.Members.EmploymentTypes,
      selectedEmploymentTypes: null as string[] | null,
      salaryExpectations: 0,
      confirmModel: {
        title: "",
        text: "",
      },
      professeionalDetail: {
        JobRole: "",
        JobTitleId: "",
        ExperienceYear: "",
        Personality: "",
      } as ProfessionalDetailModel,
      submitting: false,
      savingLoading: false,
    };
  },
  methods: {
    goBack() {
      this.$emit("goBack", 1);
    },
    sendRequest() {
      this.$emit("sendJobRequest");
    },
    async SaveJobPreferences(event: { model: any; callbackMethod: any }) {
      this.$emit("submitExperienceJobPreferences", event);
    },
    async removeJobPreferences(props: any) {
      this.$emit("removeJobPreferences", props);
    },
    async getAllDataAndSubmit(isForLator = false) {
      if (isForLator) {
        if (!this.professeionalDetail.JobTitleId) {
          var msgModel = {
            type: "showErrorMessage",
            msg: "Title is required!",
          };
          this.$emit("showMessage", msgModel);
          var jobTitleEl = document.querySelectorAll("#professionalDetailTab #jobTitle");
          this.scrollToElement(jobTitleEl[0]);
        } else {
          this.confirmModel.title = `Save Progress for Later?`;
          this.confirmModel.text =
            "You're almost ready to move on to your personalized screening experience. Are you sure you want to save your progress for later instead?";
          this.showSaveForLaterConfirm = true;
        }
      } else {
        let isValid = (await (this.$refs.frmMain as any).validate()).valid;
        var isFormValid = isValid && this.isThereJobPreferences();
        if (isFormValid) {
          this.save(true);
        } else {
          var el;
          if (isValid && !this.isThereJobPreferences()) {
            el = document.querySelectorAll("#professionalCareerObjectiveDetailTab");
          } else {
            el = document.querySelectorAll(
              "#professionalDetailTab .v-messages__message:first-of-type, #professionalDetailTab .v-messages.v-messages__message:first-of-type"
            );
          }
          this.scrollToElement(el[0]);
        }
      }
    },
    getJobTitle(item: any) {
      this.professeionalDetail.JobTitleId = item.Name ? item.Name : item;
    },

    cancelSaving() {
      this.showSaveForLaterConfirm = false;
    },
    scrollToElement(el: any) {
      this.$emit("scrollToElement", el);
    },
    async submitForm() {
      let isValid = (await (this.$refs.frmMain as any).validate()).valid;
      var isFormValid = isValid && this.isThereJobPreferences();
      if (isFormValid) {
        this.save(false);
      } else {
        var el;
        if (isValid && !this.isThereJobPreferences()) {
          el = document.querySelectorAll("#professionalCareerObjectiveDetailTab");
        } else {
          el = document.querySelectorAll(
            "#professionalDetailTab .error--text:first-of-type, #professionalDetailTab .v-messages.error--text:first-of-type"
          );
        }
        this.scrollToElement(el[0]);
      }
    },
    employmentTypeChanged(val: any) {
      if (val && val.length === 0) {
        this.selectedEmploymentTypes = null;
      }
    },
    loadJobRoleAndJobTitle() {
      this.jobRoles = this.details.filter((item: any) => item.Type == "JobRole");
      if (this.selectedJobRole) {
        this.jobTitles = this.details.filter((item: any) => item.Type == "JobTitle" && item.RoleId === this.selectedJobRole);
      }
    },
    save(goNext: any, forLater = false) {
      if (this.professeionalDetail) {
        if (this.selectedJobRole) {
          this.professeionalDetail.JobRole = this.selectedJobRole;
        }
        if (this.selectedExperienceYear) {
          this.professeionalDetail.ExperienceYear = this.selectedExperienceYear;
        }
      }
      this.$emit("submitExperienceDetail", {
        tm: this.professeionalDetail,
        step: goNext && !forLater ? 2 : null,
      });
      this.cancelSaving();
    },
    filterJobTitleByRole() {
      this.jobTitles = this.details.filter((item: any) => item.Type == "JobTitle" && item.RoleId === this.selectedJobRole);
    },
    isThereJobPreferences(): boolean {
      return !!(this.professeionalDetail && this.teamMember.JobPreferences && this.teamMember.JobPreferences.length > 0);
    },
    selectJobTitle() {
      if (this.professeionalDetail && this.professeionalDetail?.JobTitleId) {
        var findJobTitle = this.jobTitles.find((c) => c.id === this.professeionalDetail.JobTitleId);
        if (findJobTitle) {
          this.selectedJobTitle = findJobTitle;
        }
      }
    },
  },
  watch: {
    selectedJobRole(newVal) {
      if (newVal != this.professeionalDetail.JobRole) {
        this.selectedJobTitle = null;
      }
      this.filterJobTitleByRole();
    },
    details(newVal) {
      this.loadJobRoleAndJobTitle();
    },
    formLoading(newVal) {
      this.dataLoading = newVal;
    },
    loading(newVal) {
      this.submitting = newVal;
    },
    professionalDetailModel(newVal) {
      this.professeionalDetail = { ...newVal };
      if (this.professeionalDetail?.ExperienceYear) {
        this.selectedExperienceYear = this.professeionalDetail?.ExperienceYear;
      }

      if (this.professeionalDetail?.JobRole) {
        this.selectedJobRole = this.professeionalDetail.JobRole;
        this.filterJobTitleByRole();
      }
      this.selectJobTitle();
    },
    sendReqeustLoading(newVal) {
      this.requestLoading = newVal;
    },
  },
  mounted() {
    if (this.professionalDetailModel) {
      this.professeionalDetail = {
        JobRole: this.professionalDetailModel?.JobRole ?? "",
        ExperienceYear: this.professionalDetailModel?.ExperienceYear ?? "",
        Personality: this.professionalDetailModel?.Personality ?? "",
        JobTitleId: this.professionalDetailModel?.JobTitleId ?? "",
      };
      this.selectedExperienceYear = this.professeionalDetail?.ExperienceYear ?? "";

      this.selectedJobRole = this.professeionalDetail?.JobRole ?? "";
    }
    this.loadJobRoleAndJobTitle();
    this.selectJobTitle();
    this.$emit("getProfessionalDetail");
  },
});
</script>
